import { Button, Group, Text } from "@mantine/core";
import { ConfirmAndExecutePanel, DBStatusResult, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { VisitasATiendas } from "./VisitasATiendas";

export const ACTCancelarVisita: EntityClientAction = {
    name: 'ACTCancelarVisita',
    label: 'Cancelar Visita',
    title: <Text fw={700}>Cancelar Visita</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['viti_brwVisitasPorSemana'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const visita = entity as VisitasATiendas;

        const procParms = {
            c_visita_id: selectedKeys?.[0]?.['c_visita_id'] ?? ''
        };

        let errores = '';

        if (!procParms.c_visita_id) {
            errores = 'Los registros seleccionados son inválidos';
        }

        if (errores) {
            await modal.open({
                modalProps: {
                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                },
                focusOnClosed: element,
                content:
                    <>
                        <Text size="sm" mb="xs">
                            {errores}
                        </Text>
                        <Group mt="xs" position="right">
                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                        </Group>
                    </>
            });

        }
        else {
            const abort_controller = new AbortController();

            await modal.open({
                modalProps: {
                    title: <Text fw="700">Cancelar Visita</Text>
                },
                focusOnClosed: element,
                content: <ConfirmAndExecutePanel
                    content={<Text size="sm" mb="xs">Va a cancelar la visita. ¿Está seguro?</Text>}
                    operation="proc"
                    onCancel={async () => { await abort_controller.abort(); await modal.close(); }}
                    onOK={
                        async (): Promise<DBStatusResult> => {
                            //const visitas = Entity.clone(visita) as VisitasATiendas;

                            //visitas.def.columns.c_visita_id.value = visita.parentKeys[visita.def.columns.c_visita_id.name] as string;

                            const result = await visita.API.executeProcess(visita.def.procs.viti_CancelarVisita, procParms, abort_controller.signal, selectedKeys);

                            if (!result.Failed) {
                                if (onClose) await onClose();
                                await modal.close();
                            }

                            return result;
                        }
                    }
                />

            });
        }

        return false;
    }
}